export default __webpack_public_path__ + "static/media/tick.25ecc99f.svg";